import React from "react";
import { useLocation } from "react-router-dom";

interface PageTitleProps {
  className?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ className = "" }) => {
  const location = useLocation();

  const getPageTitle = (pathname: string): string => {
    switch (pathname) {
      case "/":
        return "Dashboard";
      case "/clientes":
        return "Clientes";
      case "/produtos":
        return "Produtos";
      case "/reservas":
        return "Reservas";
      case "/atendimento":
        return "Atendimento";
      case "/funcionarios":
        return "Funcionários";
      case "/perfil":
        return "Perfil";
      case "/devolucoes":
        return "Devoluções";
      default:
        return "SystemLoc";
    }
  };

  const getPageDescription = (pathname: string): string => {
    switch (pathname) {
      case "/":
        return "Visão geral do sistema";
      case "/clientes":
        return "Gerencie seus clientes";
      case "/produtos":
        return "Gerencie seu catálogo de produtos";
      case "/reservas":
        return "Controle suas reservas";
      case "/atendimento":
        return "Gerencie os atendimentos do dia";
      case "/funcionarios":
        return "Gerencie seus funcionários";
      case "/perfil":
        return "Configurações da sua conta";
      default:
        return "";
    }
  };

  const title = getPageTitle(location.pathname);
  const description = getPageDescription(location.pathname);

  return (
    <></>
    // <div className={`bg-white border-bottom shadow-sm ${className}`}>
    //   <div className="px-4 py-3">
    //     <h2 className="text-dark mb-1">{title}</h2>
    //     {description && (
    //       <p className="text-muted mb-0">{description}</p>
    //     )}
    //   </div>
    // </div>
  );
};

export default PageTitle;
